'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxAnchorBlock } from './AnchorBlock'

interface AnchorBlockProps {
  blok: {
    anchorId: string
    content: SbBlokData[]
    offset: number
  } & SbBlokData
}

const AnchorBlockBlok: FC<AnchorBlockProps> = ({ blok }) => {
  if (!blok.anchorId || blok.anchorId.length === 0) return null

  const scrollOffset = blok.offset ?? 0

  return (
    <div
      id={blok.anchorId}
      {...storyblokEditable(blok)}
      style={{ scrollMarginTop: `${scrollOffset}px` }}
    >
      <PhnxAnchorBlock
        content={
          blok.content &&
          blok.content.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
      />
    </div>
  )
}

export default AnchorBlockBlok
